<div class="demeter-nav-bar">
	<nav class="navbar df-navbar" data-bs-theme="dark">
		<div class="df-nav-row flex-row align-items-center container">
			<button
				type="button"
				class="btn df-nav-toggler d-flex d-lg-none"
				(click)="toggleNav()"
				aria-controls="navbar-main"
				[attr.aria-expanded]="isNavOpen"
				aria-label="Toggle navigation"
			>
				<i [class]="isNavOpen ? 'bi-x-lg' : 'bi-list'"></i>
			</button>
			<span class="navbar-brand df-brand">
				<img class="df-brand__mark" src="images/logo-mark-light.png" alt="Demeter Tactical Investments" />
				<img class="df-brand__wordmark" src="images/logo-wordmark-light.png" alt="" />
				@if (envIndicator || buildBranch) {
					<span class="df-env-chip">
						<span class="df-env-chip__env">{{ envIndicator }}</span>
						@if (showBranch) {
							<span class="df-env-chip__sep">·</span>
							@if (buildBranchUrl) {
								<a
									class="df-env-chip__branch"
									[href]="buildBranchUrl"
									target="_blank"
									rel="noopener"
									[title]="buildBranchTitle"
									>{{ buildBranch }}</a
								>
							} @else {
								<span class="df-env-chip__branch" [title]="buildBranchTitle">{{ buildBranch }}</span>
							}
						}
					</span>
				}
			</span>
			@if (isAuthResolved && !!user) {

				<div
					class="circle rounded-circle order-lg-4 fs-6 d-flex align-items-center justify-content-center fw-semibold dropdown"
				>
					<a
						class="nav-link dropdown-toggle"
						data-bs-toggle="dropdown"
						href="#"
						role="button"
						aria-expanded="false"
						>{{ userInitials }}</a
					>
					<ul class="dropdown-menu dropdown-menu-end">
						<li class="df-menu-id">
							<div class="fw-semibold">{{ userName }}</div>
							<div class="df-menu-id__mail">{{ userEmail }}</div>
						</li>
						<li><hr class="dropdown-divider" /></li>
						<li>
							<button class="dropdown-item" (click)="openSettings()">
								<i class="bi bi-sliders me-2"></i>Settings
							</button>
						</li>
						<li>
							<button class="dropdown-item" (click)="onLogout()">
								<i class="bi bi-box-arrow-right me-2"></i>Sign out
							</button>
						</li>
					</ul>
				</div>
			}
			@if (isAuthResolved && !user) {
				<div class="text-bg-primary order-lg-4 rounded">
					<button
						type="button"
						class="btn btn-primary d-flex flex-row align-items-center justify-content-center"
						(click)="onLogin()"
					>
						<div class="pe-2"><i class="bi-person"></i></div>
						<span class="text-nowrap">SIGN IN</span>
					</button>
				</div>
			}
		</div>
		<div
			class="nav navbar-nav align-items-stretch flex-nowrap flex-lg-grow-1 d-lg-flex flex-column flex-lg-row navbar-collapse collapse"
			id="navbar-main"
		>
			@if (isAuthResolved && !!user) {

			@for (ITEM of visibleNavItems; track $index; let i = $index) {
				@if (isMobileNav() && showGroupSeparatorBefore(i)) {
					<div class="df-panel-sep"></div>
				}
				<df-nav-bar-item
					[item]="ITEM"
					[isActive]="isItemActive(ITEM)"
					[isMobileNav]="isMobileNav()"
					(action)="onItemAction($event)"
				></df-nav-bar-item>
			}
		}
		</div>
	</nav>
</div>
